import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import {
  SubscribeWrapper,
  Checkbox,
  OptInWrapper,
  CheckboxWrapper,
  Title,
  OptInInfo,
  CheckoutBoxesWrapper,
  CheckboxText
} from './CheckoutPage.style';

const Subscribe = ({consumer}) => {
  const renderEmailCheckbox = (!consumer || !(consumer && consumer.emailSubscription)) && (
     <CheckboxWrapper>
      <Checkbox
        id="emailSubscription"
        name="emailSubscription"
        component="input"
        type="checkbox"
      />
      <CheckboxText htmlFor="emailSubscription">
        <FormattedMessage id="checkout.byEmail" />
      </CheckboxText>
    </CheckboxWrapper>
  );
  const renderTextCheckbox = (!consumer || !(consumer && consumer.phoneSubscription)) && (
    <CheckboxWrapper>
      <Checkbox
        id="phoneSubscription"
        name="phoneSubscription"
        component="input"
        type="checkbox"
      />
      <CheckboxText htmlFor="phoneSubscription">
        <FormattedMessage id="checkout.byText" />
      </CheckboxText>
    </CheckboxWrapper>
  );

  return (
    <SubscribeWrapper>
      <OptInWrapper>
        <Title>
          <FormattedMessage id="checkout.subscribe" />
        </Title>
        <CheckoutBoxesWrapper>
          {renderEmailCheckbox}
          {renderTextCheckbox}
        </CheckoutBoxesWrapper>
      </OptInWrapper>
      <OptInInfo>
        <FormattedMessage id="checkout.subscribeInfo" />
      </OptInInfo>
    </SubscribeWrapper>
  );
};

Subscribe.propTypes = {
  consumer: PropTypes.object
};

export default Subscribe;



// WEBPACK FOOTER //
// ./containers/CheckoutPage/Subscribe.js